/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AttributeQueryDTO,
  AttributeStyleSettingsParamsDTO,
  AttributesDTO,
  AttributesSearchResultDTO,
  AttributesStyleSettingsResultDTO,
  AttributesTreeSearchResultDTO,
  BulkOpResultDTO,
  DashboardDTO,
  DashboardListDTO,
  DashboardVersionDTO,
  DependencyOnInaccessibleProjectsErrorDTO,
  EvaluationChartRequest,
  EvaluationChartResponse,
  EvaluationMetricsRequest,
  EvaluationMetricsResponse,
  EvaluationRecordsRequest,
  EvaluationRecordsResponse,
  EvaluationSource,
  Experiment,
  ExperimentAttributesDTO,
  FloatSeriesValuesDTO,
  FloatTimeSeriesValuesRequest,
  GenericErrorResponse,
  GlobalSearchParamsDTO,
  HealthCheckStatusDTO,
  HistogramSeriesViewRequest,
  HistogramSeriesViewResponse,
  LeaderboardEntriesSearchResultDTO,
  LeaderboardViewDTO,
  LeaderboardViewListDTO,
  LeaderboardViewSetDefaultDTO,
  LeaderboardViewUpdateDTO,
  MultiSearchLeaderboardEntriesParamsDTO,
  NewDashboardDTO,
  NewLeaderboardViewDTO,
  NewRunColorListDTO,
  NewVersionDashboardDTO,
  Operation,
  OperationError,
  PageDTODashboardVersionDTO,
  ProjectBulkOpResultDTO,
  PutRunColorsParamsDTO,
  QueryAttributeDefinitionsBodyDTO,
  QueryAttributeDefinitionsDTO,
  QueryAttributeDefinitionsPrioritizedBodyDTO,
  QueryAttributeDefinitionsPrioritizedResultDTO,
  QueryAttributeDefinitionsResultDTO,
  QueryAttributeValuesBodyDTO,
  QueryAttributeValuesResultDTO,
  QueryAttributesBodyDTO,
  QueryAttributesResultDTO,
  QueryRunColorsParamsDTO,
  ReportMetadataListDTO,
  ReportVersionDTO,
  ReportVersionListDTO,
  ReportVersionMetadataDTO,
  RunColorListDTO,
  RunColorListsDTO,
  RunColorsDTO,
  RunListDTO,
  RunsAttributesDTO,
  RunsAttributesQueryDTO,
  SearchAttributesStyleSettingsParamsDTO,
  SearchLeaderboardEntriesParamsDTO,
  SearchLeaderboardParamsDTO,
  SearchUserRunsParamsDTO,
  SeriesPointSourceRequestDTO,
  SeriesPointSourceResponseDTO,
  SeriesValuesRequest,
  SeriesValuesResponseDTO,
  SessionEventDTO,
  StringSeriesValuesDTO,
  TagsSearchResultDTO,
  TimeSeriesViewRequest,
  TimeSeriesViewResponse,
  TrackingDataDTO,
  UpdateDashboardDTO,
  UpdateDashboardVersionDTO,
  UpdateTagsBulkParams,
  UpdateTagsParams,
  UserEventDTO,
  UserSessionDTO,
  UserSessionInfoDTO,
} from '../models/index';
import {
    AttributeQueryDTOFromJSON,
    AttributeQueryDTOToJSON,
    AttributeStyleSettingsParamsDTOFromJSON,
    AttributeStyleSettingsParamsDTOToJSON,
    AttributesDTOFromJSON,
    AttributesDTOToJSON,
    AttributesSearchResultDTOFromJSON,
    AttributesSearchResultDTOToJSON,
    AttributesStyleSettingsResultDTOFromJSON,
    AttributesStyleSettingsResultDTOToJSON,
    AttributesTreeSearchResultDTOFromJSON,
    AttributesTreeSearchResultDTOToJSON,
    BulkOpResultDTOFromJSON,
    BulkOpResultDTOToJSON,
    DashboardDTOFromJSON,
    DashboardDTOToJSON,
    DashboardListDTOFromJSON,
    DashboardListDTOToJSON,
    DashboardVersionDTOFromJSON,
    DashboardVersionDTOToJSON,
    DependencyOnInaccessibleProjectsErrorDTOFromJSON,
    DependencyOnInaccessibleProjectsErrorDTOToJSON,
    EvaluationChartRequestFromJSON,
    EvaluationChartRequestToJSON,
    EvaluationChartResponseFromJSON,
    EvaluationChartResponseToJSON,
    EvaluationMetricsRequestFromJSON,
    EvaluationMetricsRequestToJSON,
    EvaluationMetricsResponseFromJSON,
    EvaluationMetricsResponseToJSON,
    EvaluationRecordsRequestFromJSON,
    EvaluationRecordsRequestToJSON,
    EvaluationRecordsResponseFromJSON,
    EvaluationRecordsResponseToJSON,
    EvaluationSourceFromJSON,
    EvaluationSourceToJSON,
    ExperimentFromJSON,
    ExperimentToJSON,
    ExperimentAttributesDTOFromJSON,
    ExperimentAttributesDTOToJSON,
    FloatSeriesValuesDTOFromJSON,
    FloatSeriesValuesDTOToJSON,
    FloatTimeSeriesValuesRequestFromJSON,
    FloatTimeSeriesValuesRequestToJSON,
    GenericErrorResponseFromJSON,
    GenericErrorResponseToJSON,
    GlobalSearchParamsDTOFromJSON,
    GlobalSearchParamsDTOToJSON,
    HealthCheckStatusDTOFromJSON,
    HealthCheckStatusDTOToJSON,
    HistogramSeriesViewRequestFromJSON,
    HistogramSeriesViewRequestToJSON,
    HistogramSeriesViewResponseFromJSON,
    HistogramSeriesViewResponseToJSON,
    LeaderboardEntriesSearchResultDTOFromJSON,
    LeaderboardEntriesSearchResultDTOToJSON,
    LeaderboardViewDTOFromJSON,
    LeaderboardViewDTOToJSON,
    LeaderboardViewListDTOFromJSON,
    LeaderboardViewListDTOToJSON,
    LeaderboardViewSetDefaultDTOFromJSON,
    LeaderboardViewSetDefaultDTOToJSON,
    LeaderboardViewUpdateDTOFromJSON,
    LeaderboardViewUpdateDTOToJSON,
    MultiSearchLeaderboardEntriesParamsDTOFromJSON,
    MultiSearchLeaderboardEntriesParamsDTOToJSON,
    NewDashboardDTOFromJSON,
    NewDashboardDTOToJSON,
    NewLeaderboardViewDTOFromJSON,
    NewLeaderboardViewDTOToJSON,
    NewRunColorListDTOFromJSON,
    NewRunColorListDTOToJSON,
    NewVersionDashboardDTOFromJSON,
    NewVersionDashboardDTOToJSON,
    OperationFromJSON,
    OperationToJSON,
    OperationErrorFromJSON,
    OperationErrorToJSON,
    PageDTODashboardVersionDTOFromJSON,
    PageDTODashboardVersionDTOToJSON,
    ProjectBulkOpResultDTOFromJSON,
    ProjectBulkOpResultDTOToJSON,
    PutRunColorsParamsDTOFromJSON,
    PutRunColorsParamsDTOToJSON,
    QueryAttributeDefinitionsBodyDTOFromJSON,
    QueryAttributeDefinitionsBodyDTOToJSON,
    QueryAttributeDefinitionsDTOFromJSON,
    QueryAttributeDefinitionsDTOToJSON,
    QueryAttributeDefinitionsPrioritizedBodyDTOFromJSON,
    QueryAttributeDefinitionsPrioritizedBodyDTOToJSON,
    QueryAttributeDefinitionsPrioritizedResultDTOFromJSON,
    QueryAttributeDefinitionsPrioritizedResultDTOToJSON,
    QueryAttributeDefinitionsResultDTOFromJSON,
    QueryAttributeDefinitionsResultDTOToJSON,
    QueryAttributeValuesBodyDTOFromJSON,
    QueryAttributeValuesBodyDTOToJSON,
    QueryAttributeValuesResultDTOFromJSON,
    QueryAttributeValuesResultDTOToJSON,
    QueryAttributesBodyDTOFromJSON,
    QueryAttributesBodyDTOToJSON,
    QueryAttributesResultDTOFromJSON,
    QueryAttributesResultDTOToJSON,
    QueryRunColorsParamsDTOFromJSON,
    QueryRunColorsParamsDTOToJSON,
    ReportMetadataListDTOFromJSON,
    ReportMetadataListDTOToJSON,
    ReportVersionDTOFromJSON,
    ReportVersionDTOToJSON,
    ReportVersionListDTOFromJSON,
    ReportVersionListDTOToJSON,
    ReportVersionMetadataDTOFromJSON,
    ReportVersionMetadataDTOToJSON,
    RunColorListDTOFromJSON,
    RunColorListDTOToJSON,
    RunColorListsDTOFromJSON,
    RunColorListsDTOToJSON,
    RunColorsDTOFromJSON,
    RunColorsDTOToJSON,
    RunListDTOFromJSON,
    RunListDTOToJSON,
    RunsAttributesDTOFromJSON,
    RunsAttributesDTOToJSON,
    RunsAttributesQueryDTOFromJSON,
    RunsAttributesQueryDTOToJSON,
    SearchAttributesStyleSettingsParamsDTOFromJSON,
    SearchAttributesStyleSettingsParamsDTOToJSON,
    SearchLeaderboardEntriesParamsDTOFromJSON,
    SearchLeaderboardEntriesParamsDTOToJSON,
    SearchLeaderboardParamsDTOFromJSON,
    SearchLeaderboardParamsDTOToJSON,
    SearchUserRunsParamsDTOFromJSON,
    SearchUserRunsParamsDTOToJSON,
    SeriesPointSourceRequestDTOFromJSON,
    SeriesPointSourceRequestDTOToJSON,
    SeriesPointSourceResponseDTOFromJSON,
    SeriesPointSourceResponseDTOToJSON,
    SeriesValuesRequestFromJSON,
    SeriesValuesRequestToJSON,
    SeriesValuesResponseDTOFromJSON,
    SeriesValuesResponseDTOToJSON,
    SessionEventDTOFromJSON,
    SessionEventDTOToJSON,
    StringSeriesValuesDTOFromJSON,
    StringSeriesValuesDTOToJSON,
    TagsSearchResultDTOFromJSON,
    TagsSearchResultDTOToJSON,
    TimeSeriesViewRequestFromJSON,
    TimeSeriesViewRequestToJSON,
    TimeSeriesViewResponseFromJSON,
    TimeSeriesViewResponseToJSON,
    TrackingDataDTOFromJSON,
    TrackingDataDTOToJSON,
    UpdateDashboardDTOFromJSON,
    UpdateDashboardDTOToJSON,
    UpdateDashboardVersionDTOFromJSON,
    UpdateDashboardVersionDTOToJSON,
    UpdateTagsBulkParamsFromJSON,
    UpdateTagsBulkParamsToJSON,
    UpdateTagsParamsFromJSON,
    UpdateTagsParamsToJSON,
    UserEventDTOFromJSON,
    UserEventDTOToJSON,
    UserSessionDTOFromJSON,
    UserSessionDTOToJSON,
    UserSessionInfoDTOFromJSON,
    UserSessionInfoDTOToJSON,
} from '../models/index';

export interface ArchiveRunsRequest {
    runList: RunListDTO;
    xNeptuneClientMetadata?: string;
}

export interface CreateDashboardRequest {
    projectIdentifier: string;
    createDashboard: NewDashboardDTO;
    xNeptuneClientMetadata?: string;
}

export interface CreateLeaderboardViewRequest {
    projectIdentifier: string;
    createView: NewLeaderboardViewDTO;
    xNeptuneClientMetadata?: string;
}

export interface CreateNewVersionOfDashboardRequest {
    dashboardId: string;
    projectIdentifier: string;
    createVersionDashboard: NewVersionDashboardDTO;
    xNeptuneClientMetadata?: string;
}

export interface CreateReportVersionRequest {
    projectIdentifier: string;
    reportVersion: ReportVersionDTO;
    xNeptuneClientMetadata?: string;
    reportId?: string;
}

export interface CreateRunColorListRequest {
    projectIdentifier: string;
    colorList: NewRunColorListDTO;
    xNeptuneClientMetadata?: string;
}

export interface DeleteAllDashboardVersionsRequest {
    branchVersionId: string;
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
}

export interface DeleteAllReportVersionsRequest {
    projectIdentifier: string;
    reportId: string;
    xNeptuneClientMetadata?: string;
}

export interface DeleteDashboardRequest {
    dashboardId: string;
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
}

export interface DeleteLeaderboardViewRequest {
    projectIdentifier: string;
    viewId: string;
    xNeptuneClientMetadata?: string;
}

export interface DeleteReportVersionRequest {
    projectIdentifier: string;
    reportId: string;
    versionId: string;
    xNeptuneClientMetadata?: string;
}

export interface DiscoverCommonEvaluationMetricsRequest {
    request: EvaluationMetricsRequest;
    xNeptuneClientMetadata?: string;
}

export interface DiscoverEvaluationMetricsRequest {
    source: EvaluationSource;
    xNeptuneClientMetadata?: string;
}

export interface ExecuteOperationsRequest {
    operations: Array<Operation>;
    userAgent?: string;
    xNeptuneClientMetadata?: string;
    experimentId?: string;
    holderIdentifier?: string;
    holderType?: string;
}

export interface FinishAuditSessionRequest {
    xNeptuneClientMetadata?: string;
}

export interface GetAttributesRequest {
    xNeptuneClientMetadata?: string;
    holderIdentifier?: string;
    holderType?: string;
}

export interface GetAttributesForRunsAndExperimentsRequest {
    attributeQuery: RunsAttributesQueryDTO;
    xNeptuneClientMetadata?: string;
}

export interface GetAttributesWithPathsFilterRequest {
    xNeptuneClientMetadata?: string;
    holderIdentifier?: string;
    holderType?: string;
    attributeQuery?: AttributeQueryDTO;
}

export interface GetAttributesWithPathsFilterProtoRequest {
    holderIdentifier: string;
    xNeptuneClientMetadata?: string;
    holderType?: string;
    attributeQuery?: AttributeQueryDTO;
}

export interface GetDashboardRequest {
    dashboardId: string;
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
}

export interface GetEvaluationChartRequest {
    request: EvaluationChartRequest;
    xNeptuneClientMetadata?: string;
}

export interface GetEvaluationRecordsRequest {
    request: EvaluationRecordsRequest;
    xNeptuneClientMetadata?: string;
}

export interface GetExperimentRequest {
    experimentId: string;
    xNeptuneClientMetadata?: string;
}

export interface GetExperimentAttributesRequest {
    experimentId: string;
    xNeptuneClientMetadata?: string;
}

export interface GetFloatSeriesValuesRequest {
    attribute: string;
    xNeptuneClientMetadata?: string;
    experimentId?: string;
    includePreview?: boolean;
    limit?: number;
    lineage?: GetFloatSeriesValuesLineageEnum;
    lineageEntityType?: GetFloatSeriesValuesLineageEntityTypeEnum;
    skipToStep?: number;
}

export interface GetFloatSeriesValuesCSVRequest {
    attribute: string;
    xNeptuneClientMetadata?: string;
    expectedContentDisposition?: GetFloatSeriesValuesCSVExpectedContentDispositionEnum;
    experimentId?: string;
    gzipped?: boolean;
    holderIdentifier?: string;
    holderType?: string;
}

export interface GetFloatSeriesValuesProtoRequest {
    attribute: string;
    xNeptuneClientMetadata?: string;
    experimentId?: string;
    includePreview?: boolean;
    limit?: number;
    lineage?: GetFloatSeriesValuesProtoLineageEnum;
    lineageEntityType?: GetFloatSeriesValuesProtoLineageEntityTypeEnum;
    skipToStep?: number;
}

export interface GetHistogramTimeSeriesViewRequest {
    request: HistogramSeriesViewRequest;
    xNeptuneClientMetadata?: string;
}

export interface GetLatestPublishedReportVersionRequest {
    projectIdentifier: string;
    reportId: string;
    xNeptuneClientMetadata?: string;
}

export interface GetLeaderboardViewRequest {
    projectIdentifier: string;
    viewId: string;
    xNeptuneClientMetadata?: string;
}

export interface GetMultipleFloatSeriesValuesProtoRequest {
    request: FloatTimeSeriesValuesRequest;
    xNeptuneClientMetadata?: string;
}

export interface GetReportVersionRequest {
    projectIdentifier: string;
    reportId: string;
    versionId: string;
    xNeptuneClientMetadata?: string;
}

export interface GetSeriesPointSourceRequest {
    request: SeriesPointSourceRequestDTO;
    xNeptuneClientMetadata?: string;
}

export interface GetSeriesValuesRequest {
    request: SeriesValuesRequest;
    xNeptuneClientMetadata?: string;
    useDeprecatedStringFields?: boolean;
}

export interface GetSeriesValuesProtoRequest {
    request: SeriesValuesRequest;
    xNeptuneClientMetadata?: string;
    useDeprecatedStringFields?: boolean;
}

export interface GetStringSeriesValuesRequest {
    attribute: string;
    xNeptuneClientMetadata?: string;
    experimentId?: string;
    limit?: number;
    maxSingleValueLength?: number;
    offset?: number;
}

export interface GetTimeSeriesViewRequest {
    request: TimeSeriesViewRequest;
    xNeptuneClientMetadata?: string;
    projectIdentifier?: string;
}

export interface GetTimeseriesBucketsProtoRequest {
    request: object;
    xNeptuneClientMetadata?: string;
}

export interface ListDashboardBranchVersionsRequest {
    projectIdentifier: string;
    versionBranch: string;
    xNeptuneClientMetadata?: string;
    drafts?: ListDashboardBranchVersionsDraftsEnum;
    limit?: number;
    offset?: number;
    substringQuery?: string;
}

export interface ListDashboardsRequest {
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
    branchIds?: Array<string>;
    dashboardType?: ListDashboardsDashboardTypeEnum;
    drafts?: ListDashboardsDraftsEnum;
    owners?: Array<string>;
}

export interface ListLeaderboardViewsRequest {
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
}

export interface ListReportDraftsMetadataRequest {
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
    owner?: string;
    reportIds?: Array<string>;
}

export interface ListReportVersionsMetadataRequest {
    projectIdentifier: string;
    reportIds: Array<string>;
    xNeptuneClientMetadata?: string;
    searchTerm?: string;
}

export interface ListReportsMetadataRequest {
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
    reportIds?: Array<string>;
}

export interface ListRunColorListsRequest {
    projectIdentifier: string;
    xNeptuneClientMetadata?: string;
}

export interface ListTrackingDataRequest {
    projectIdentifiers: Array<string>;
    xNeptuneClientMetadata?: string;
}

export interface MultiSearchLeaderboardEntriesRequest {
    params: Array<MultiSearchLeaderboardEntriesParamsDTO>;
    xNeptuneClientMetadata?: string;
}

export interface PutAttributeStyleSettingsRequest {
    params: AttributeStyleSettingsParamsDTO;
    xNeptuneClientMetadata?: string;
}

export interface PutRunColorsRequest {
    params: PutRunColorsParamsDTO;
    xNeptuneClientMetadata?: string;
}

export interface QueryAttributeDefinitionsRequest {
    experimentIdentifier: string;
    xNeptuneClientMetadata?: string;
    attributeType?: Array<string>;
    limit?: number;
    offset?: number;
    prefix?: string;
}

export interface QueryAttributeDefinitionsOnlyWithDiffsRequest {
    projectIdentifier: string;
    query: QueryAttributeDefinitionsBodyDTO;
    xNeptuneClientMetadata?: string;
}

export interface QueryAttributeDefinitionsPrioritizedRequest {
    query: QueryAttributeDefinitionsPrioritizedBodyDTO;
    xNeptuneClientMetadata?: string;
}

export interface QueryAttributeDefinitionsProtoRequest {
    experimentIdentifier: string;
    xNeptuneClientMetadata?: string;
    attributeType?: Array<string>;
}

export interface QueryAttributeDefinitionsWithinProjectRequest {
    query: QueryAttributeDefinitionsBodyDTO;
    xNeptuneClientMetadata?: string;
    projectIdentifier?: string;
}

export interface QueryAttributeStyleSettingsRequest {
    params: SearchAttributesStyleSettingsParamsDTO;
    xNeptuneClientMetadata?: string;
}

export interface QueryAttributesWithinProjectRequest {
    query: QueryAttributesBodyDTO;
    xNeptuneClientMetadata?: string;
    projectIdentifier?: string;
}

export interface QueryAttributesWithinProjectProtoRequest {
    projectIdentifier: string;
    query: QueryAttributesBodyDTO;
    xNeptuneClientMetadata?: string;
}

export interface QueryFilteredAttributeDefinitionsRequest {
    experimentIdentifier: string;
    xNeptuneClientMetadata?: string;
    attributeType?: Array<string>;
    queryAttributeDefinitionsDTO?: QueryAttributeDefinitionsDTO;
}

export interface QueryRunColorsRequest {
    params: QueryRunColorsParamsDTO;
    xNeptuneClientMetadata?: string;
}

export interface QueryUniqueAttributeValuesRequest {
    projectIdentifier: string;
    query: QueryAttributeValuesBodyDTO;
    xNeptuneClientMetadata?: string;
}

export interface ResumeStatusUsingPOSTRequest {
    xNeptuneClientMetadata?: string;
}

export interface RetrieveAuditSessionRequest {
    sessionId: string;
    xNeptuneClientMetadata?: string;
}

export interface SearchGlobalLeaderboardEntriesProtoRequest {
    params: GlobalSearchParamsDTO;
    xNeptuneClientMetadata?: string;
}

export interface SearchLeaderboardAttributesRequest {
    projectIdentifier: string;
    params: SearchLeaderboardParamsDTO;
    xNeptuneClientMetadata?: string;
    attributeType?: Array<string>;
    limit?: number;
    search?: string;
    type?: Array<string>;
}

export interface SearchLeaderboardEntriesRequest {
    projectIdentifier: string;
    params: SearchLeaderboardEntriesParamsDTO;
    xNeptuneClientMetadata?: string;
    type?: Array<string>;
}

export interface SearchLeaderboardEntriesProtoRequest {
    projectIdentifier: string;
    params: SearchLeaderboardEntriesParamsDTO;
    xNeptuneClientMetadata?: string;
    type?: Array<string>;
}

export interface SearchLeaderboardTagsRequest {
    projectIdentifier: string;
    params: SearchLeaderboardParamsDTO;
    xNeptuneClientMetadata?: string;
    attributePath?: SearchLeaderboardTagsAttributePathEnum;
    search?: string;
    type?: Array<string>;
}

export interface SearchUserRunsRequest {
    params: SearchUserRunsParamsDTO;
    xNeptuneClientMetadata?: string;
}

export interface SetDefaultViewRequest {
    setDefaultOperation: LeaderboardViewSetDefaultDTO;
    xNeptuneClientMetadata?: string;
}

export interface StartOrContinueAuditSessionRequest {
    xNeptuneClientMetadata?: string;
}

export interface StoreAuditEventRequest {
    event: SessionEventDTO;
    xNeptuneClientMetadata?: string;
}

export interface StoreEventRequest {
    event: UserEventDTO;
    xNeptuneClientMetadata?: string;
}

export interface SuspendStatusUsingPOSTRequest {
    xNeptuneClientMetadata?: string;
}

export interface SystemStatusRequest {
    xNeptuneClientMetadata?: string;
}

export interface UnarchiveRunsRequest {
    runList: RunListDTO;
    xNeptuneClientMetadata?: string;
}

export interface UpdateDashboardRequest {
    dashboardId: string;
    projectIdentifier: string;
    updateDashboard: UpdateDashboardDTO;
    xNeptuneClientMetadata?: string;
}

export interface UpdateDashboardVersionRequest {
    dashboardId: string;
    projectIdentifier: string;
    updateDashboardVersionDTO: UpdateDashboardVersionDTO;
    xNeptuneClientMetadata?: string;
    updateTimestamp?: boolean;
}

export interface UpdateLeaderboardViewRequest {
    projectIdentifier: string;
    viewId: string;
    updateView: LeaderboardViewUpdateDTO;
    xNeptuneClientMetadata?: string;
}

export interface UpdateReportDraftRequest {
    projectIdentifier: string;
    publishIfUnmodifiedSince: Date;
    reportId: string;
    versionId: string;
    reportDraft: ReportVersionDTO;
    xNeptuneClientMetadata?: string;
}

export interface UpdateReportVersionMetadataRequest {
    projectIdentifier: string;
    publishIfUnmodifiedSince: Date;
    reportId: string;
    versionId: string;
    metadata: Omit<ReportVersionMetadataDTO, 'reportId'|'versionAuthor'|'versionCreationTime'|'versionId'|'versionLastModificationTime'>;
    xNeptuneClientMetadata?: string;
}

export interface UpdateTags2Request {
    projectIdentifier: string;
    updateTagsParams: UpdateTagsParams;
    xNeptuneClientMetadata?: string;
}

export interface UpdateTagsBulkRequest {
    updateTagsBulkParams: UpdateTagsBulkParams;
    xNeptuneClientMetadata?: string;
}

export interface ValidateExperimentsClipboardRequest {
    projectIdentifier: string;
    trashed: boolean;
    xNeptuneClientMetadata?: string;
    experimentIdentifiers?: Array<string>;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Archive Runs
     */
    async archiveRunsRaw(requestParameters: ArchiveRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkOpResultDTO>> {
        if (requestParameters['runList'] == null) {
            throw new runtime.RequiredError(
                'runList',
                'Required parameter "runList" was null or undefined when calling archiveRuns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runs:archive`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunListDTOToJSON(requestParameters['runList']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkOpResultDTOFromJSON(jsonValue));
    }

    /**
     * Archive Runs
     */
    async archiveRuns(requestParameters: ArchiveRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkOpResultDTO> {
        const response = await this.archiveRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create dashboard
     */
    async createDashboardRaw(requestParameters: CreateDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling createDashboard().'
            );
        }

        if (requestParameters['createDashboard'] == null) {
            throw new runtime.RequiredError(
                'createDashboard',
                'Required parameter "createDashboard" was null or undefined when calling createDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewDashboardDTOToJSON(requestParameters['createDashboard']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardDTOFromJSON(jsonValue));
    }

    /**
     * Create dashboard
     */
    async createDashboard(requestParameters: CreateDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardDTO> {
        const response = await this.createDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create view in project
     */
    async createLeaderboardViewRaw(requestParameters: CreateLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardViewDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling createLeaderboardView().'
            );
        }

        if (requestParameters['createView'] == null) {
            throw new runtime.RequiredError(
                'createView',
                'Required parameter "createView" was null or undefined when calling createLeaderboardView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/views`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewLeaderboardViewDTOToJSON(requestParameters['createView']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardViewDTOFromJSON(jsonValue));
    }

    /**
     * Create view in project
     */
    async createLeaderboardView(requestParameters: CreateLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardViewDTO> {
        const response = await this.createLeaderboardViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new updated version of dashboard
     */
    async createNewVersionOfDashboardRaw(requestParameters: CreateNewVersionOfDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardDTO>> {
        if (requestParameters['dashboardId'] == null) {
            throw new runtime.RequiredError(
                'dashboardId',
                'Required parameter "dashboardId" was null or undefined when calling createNewVersionOfDashboard().'
            );
        }

        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling createNewVersionOfDashboard().'
            );
        }

        if (requestParameters['createVersionDashboard'] == null) {
            throw new runtime.RequiredError(
                'createVersionDashboard',
                'Required parameter "createVersionDashboard" was null or undefined when calling createNewVersionOfDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/{dashboardId}/version`.replace(`{${"dashboardId"}}`, encodeURIComponent(String(requestParameters['dashboardId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewVersionDashboardDTOToJSON(requestParameters['createVersionDashboard']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardDTOFromJSON(jsonValue));
    }

    /**
     * Create new updated version of dashboard
     */
    async createNewVersionOfDashboard(requestParameters: CreateNewVersionOfDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardDTO> {
        const response = await this.createNewVersionOfDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new report version
     */
    async createReportVersionRaw(requestParameters: CreateReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling createReportVersion().'
            );
        }

        if (requestParameters['reportVersion'] == null) {
            throw new runtime.RequiredError(
                'reportVersion',
                'Required parameter "reportVersion" was null or undefined when calling createReportVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['reportId'] != null) {
            queryParameters['reportId'] = requestParameters['reportId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportVersionDTOToJSON(requestParameters['reportVersion']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionDTOFromJSON(jsonValue));
    }

    /**
     * Create a new report version
     */
    async createReportVersion(requestParameters: CreateReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionDTO> {
        const response = await this.createReportVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create run color list in project
     */
    async createRunColorListRaw(requestParameters: CreateRunColorListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunColorListDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling createRunColorList().'
            );
        }

        if (requestParameters['colorList'] == null) {
            throw new runtime.RequiredError(
                'colorList',
                'Required parameter "colorList" was null or undefined when calling createRunColorList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runColorLists`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRunColorListDTOToJSON(requestParameters['colorList']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RunColorListDTOFromJSON(jsonValue));
    }

    /**
     * Create run color list in project
     */
    async createRunColorList(requestParameters: CreateRunColorListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RunColorListDTO> {
        const response = await this.createRunColorListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete all versions of a dashboard by branch version
     */
    async deleteAllDashboardVersionsRaw(requestParameters: DeleteAllDashboardVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['branchVersionId'] == null) {
            throw new runtime.RequiredError(
                'branchVersionId',
                'Required parameter "branchVersionId" was null or undefined when calling deleteAllDashboardVersions().'
            );
        }

        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling deleteAllDashboardVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/branch/{branchVersionId}`.replace(`{${"branchVersionId"}}`, encodeURIComponent(String(requestParameters['branchVersionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all versions of a dashboard by branch version
     */
    async deleteAllDashboardVersions(requestParameters: DeleteAllDashboardVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllDashboardVersionsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete all versions of a report
     */
    async deleteAllReportVersionsRaw(requestParameters: DeleteAllReportVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling deleteAllReportVersions().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling deleteAllReportVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/{reportId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all versions of a report
     */
    async deleteAllReportVersions(requestParameters: DeleteAllReportVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllReportVersionsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete dashboard
     */
    async deleteDashboardRaw(requestParameters: DeleteDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dashboardId'] == null) {
            throw new runtime.RequiredError(
                'dashboardId',
                'Required parameter "dashboardId" was null or undefined when calling deleteDashboard().'
            );
        }

        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling deleteDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/{dashboardId}`.replace(`{${"dashboardId"}}`, encodeURIComponent(String(requestParameters['dashboardId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete dashboard
     */
    async deleteDashboard(requestParameters: DeleteDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDashboardRaw(requestParameters, initOverrides);
    }

    /**
     * Delete view
     */
    async deleteLeaderboardViewRaw(requestParameters: DeleteLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling deleteLeaderboardView().'
            );
        }

        if (requestParameters['viewId'] == null) {
            throw new runtime.RequiredError(
                'viewId',
                'Required parameter "viewId" was null or undefined when calling deleteLeaderboardView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/views/{viewId}`.replace(`{${"viewId"}}`, encodeURIComponent(String(requestParameters['viewId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete view
     */
    async deleteLeaderboardView(requestParameters: DeleteLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLeaderboardViewRaw(requestParameters, initOverrides);
    }

    /**
     * Delete version of a report; currently only drafts can be deleted
     */
    async deleteReportVersionRaw(requestParameters: DeleteReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling deleteReportVersion().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling deleteReportVersion().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling deleteReportVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/{reportId}/versions/{versionId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete version of a report; currently only drafts can be deleted
     */
    async deleteReportVersion(requestParameters: DeleteReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReportVersionRaw(requestParameters, initOverrides);
    }

    /**
     * Discover evaluation metrics shared by all sources
     */
    async discoverCommonEvaluationMetricsRaw(requestParameters: DiscoverCommonEvaluationMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvaluationMetricsResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling discoverCommonEvaluationMetrics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/evaluations/metrics/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EvaluationMetricsRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvaluationMetricsResponseFromJSON(jsonValue));
    }

    /**
     * Discover evaluation metrics shared by all sources
     */
    async discoverCommonEvaluationMetrics(requestParameters: DiscoverCommonEvaluationMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvaluationMetricsResponse> {
        const response = await this.discoverCommonEvaluationMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discover registered evaluation metrics
     */
    async discoverEvaluationMetricsRaw(requestParameters: DiscoverEvaluationMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvaluationMetricsResponse>> {
        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling discoverEvaluationMetrics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/evaluations/metrics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EvaluationSourceToJSON(requestParameters['source']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvaluationMetricsResponseFromJSON(jsonValue));
    }

    /**
     * Discover registered evaluation metrics
     */
    async discoverEvaluationMetrics(requestParameters: DiscoverEvaluationMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvaluationMetricsResponse> {
        const response = await this.discoverEvaluationMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Execute operations
     */
    async executeOperationsRaw(requestParameters: ExecuteOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OperationError>>> {
        if (requestParameters['operations'] == null) {
            throw new runtime.RequiredError(
                'operations',
                'Required parameter "operations" was null or undefined when calling executeOperations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        if (requestParameters['holderIdentifier'] != null) {
            queryParameters['holderIdentifier'] = requestParameters['holderIdentifier'];
        }

        if (requestParameters['holderType'] != null) {
            queryParameters['holderType'] = requestParameters['holderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/operations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['operations']!.map(OperationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OperationErrorFromJSON));
    }

    /**
     * Execute operations
     */
    async executeOperations(requestParameters: ExecuteOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OperationError>> {
        const response = await this.executeOperationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finish session
     */
    async finishAuditSessionRaw(requestParameters: FinishAuditSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/audited-sessions/finish`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish session
     */
    async finishAuditSession(requestParameters: FinishAuditSessionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finishAuditSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Get attributes
     */
    async getAttributesRaw(requestParameters: GetAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttributesDTO>> {
        const queryParameters: any = {};

        if (requestParameters['holderIdentifier'] != null) {
            queryParameters['holderIdentifier'] = requestParameters['holderIdentifier'];
        }

        if (requestParameters['holderType'] != null) {
            queryParameters['holderType'] = requestParameters['holderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/attributes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttributesDTOFromJSON(jsonValue));
    }

    /**
     * Get attributes
     */
    async getAttributes(requestParameters: GetAttributesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttributesDTO> {
        const response = await this.getAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get attributes for runs and experiments
     */
    async getAttributesForRunsAndExperimentsRaw(requestParameters: GetAttributesForRunsAndExperimentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunsAttributesDTO>> {
        if (requestParameters['attributeQuery'] == null) {
            throw new runtime.RequiredError(
                'attributeQuery',
                'Required parameter "attributeQuery" was null or undefined when calling getAttributesForRunsAndExperiments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/listForRuns`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunsAttributesQueryDTOToJSON(requestParameters['attributeQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RunsAttributesDTOFromJSON(jsonValue));
    }

    /**
     * Get attributes for runs and experiments
     */
    async getAttributesForRunsAndExperiments(requestParameters: GetAttributesForRunsAndExperimentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RunsAttributesDTO> {
        const response = await this.getAttributesForRunsAndExperimentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get attributes
     */
    async getAttributesWithPathsFilterRaw(requestParameters: GetAttributesWithPathsFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttributesDTO>> {
        const queryParameters: any = {};

        if (requestParameters['holderIdentifier'] != null) {
            queryParameters['holderIdentifier'] = requestParameters['holderIdentifier'];
        }

        if (requestParameters['holderType'] != null) {
            queryParameters['holderType'] = requestParameters['holderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/attributes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttributeQueryDTOToJSON(requestParameters['attributeQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttributesDTOFromJSON(jsonValue));
    }

    /**
     * Get attributes
     */
    async getAttributesWithPathsFilter(requestParameters: GetAttributesWithPathsFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttributesDTO> {
        const response = await this.getAttributesWithPathsFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get attributes
     */
    async getAttributesWithPathsFilterProtoRaw(requestParameters: GetAttributesWithPathsFilterProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['holderIdentifier'] == null) {
            throw new runtime.RequiredError(
                'holderIdentifier',
                'Required parameter "holderIdentifier" was null or undefined when calling getAttributesWithPathsFilterProto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['holderIdentifier'] != null) {
            queryParameters['holderIdentifier'] = requestParameters['holderIdentifier'];
        }

        if (requestParameters['holderType'] != null) {
            queryParameters['holderType'] = requestParameters['holderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/attributes/attributes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttributeQueryDTOToJSON(requestParameters['attributeQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get attributes
     */
    async getAttributesWithPathsFilterProto(requestParameters: GetAttributesWithPathsFilterProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getAttributesWithPathsFilterProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dashboard
     */
    async getDashboardRaw(requestParameters: GetDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardDTO>> {
        if (requestParameters['dashboardId'] == null) {
            throw new runtime.RequiredError(
                'dashboardId',
                'Required parameter "dashboardId" was null or undefined when calling getDashboard().'
            );
        }

        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling getDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/{dashboardId}`.replace(`{${"dashboardId"}}`, encodeURIComponent(String(requestParameters['dashboardId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardDTOFromJSON(jsonValue));
    }

    /**
     * Get dashboard
     */
    async getDashboard(requestParameters: GetDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardDTO> {
        const response = await this.getDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get chart-ready evaluation lines
     */
    async getEvaluationChartRaw(requestParameters: GetEvaluationChartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvaluationChartResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getEvaluationChart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/evaluations/chart`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EvaluationChartRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvaluationChartResponseFromJSON(jsonValue));
    }

    /**
     * Get chart-ready evaluation lines
     */
    async getEvaluationChart(requestParameters: GetEvaluationChartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvaluationChartResponse> {
        const response = await this.getEvaluationChartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a page of raw typed evaluation values
     */
    async getEvaluationRecordsRaw(requestParameters: GetEvaluationRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvaluationRecordsResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getEvaluationRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/evaluations/records`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EvaluationRecordsRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvaluationRecordsResponseFromJSON(jsonValue));
    }

    /**
     * Get a page of raw typed evaluation values
     */
    async getEvaluationRecords(requestParameters: GetEvaluationRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvaluationRecordsResponse> {
        const response = await this.getEvaluationRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get experiment
     */
    async getExperimentRaw(requestParameters: GetExperimentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Experiment>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling getExperiment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/experiments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentFromJSON(jsonValue));
    }

    /**
     * Get experiment
     */
    async getExperiment(requestParameters: GetExperimentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Experiment> {
        const response = await this.getExperimentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get experiment attributes
     */
    async getExperimentAttributesRaw(requestParameters: GetExperimentAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentAttributesDTO>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling getExperimentAttributes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentAttributesDTOFromJSON(jsonValue));
    }

    /**
     * Get experiment attributes
     */
    async getExperimentAttributes(requestParameters: GetExperimentAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentAttributesDTO> {
        const response = await this.getExperimentAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get float series values
     */
    async getFloatSeriesValuesRaw(requestParameters: GetFloatSeriesValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FloatSeriesValuesDTO>> {
        if (requestParameters['attribute'] == null) {
            throw new runtime.RequiredError(
                'attribute',
                'Required parameter "attribute" was null or undefined when calling getFloatSeriesValues().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attribute'] != null) {
            queryParameters['attribute'] = requestParameters['attribute'];
        }

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        if (requestParameters['includePreview'] != null) {
            queryParameters['includePreview'] = requestParameters['includePreview'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['lineage'] != null) {
            queryParameters['lineage'] = requestParameters['lineage'];
        }

        if (requestParameters['lineageEntityType'] != null) {
            queryParameters['lineageEntityType'] = requestParameters['lineageEntityType'];
        }

        if (requestParameters['skipToStep'] != null) {
            queryParameters['skipToStep'] = requestParameters['skipToStep'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/series/float`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FloatSeriesValuesDTOFromJSON(jsonValue));
    }

    /**
     * Get float series values
     */
    async getFloatSeriesValues(requestParameters: GetFloatSeriesValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FloatSeriesValuesDTO> {
        const response = await this.getFloatSeriesValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get values of a float series
     */
    async getFloatSeriesValuesCSVRaw(requestParameters: GetFloatSeriesValuesCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['attribute'] == null) {
            throw new runtime.RequiredError(
                'attribute',
                'Required parameter "attribute" was null or undefined when calling getFloatSeriesValuesCSV().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attribute'] != null) {
            queryParameters['attribute'] = requestParameters['attribute'];
        }

        if (requestParameters['expectedContentDisposition'] != null) {
            queryParameters['expectedContentDisposition'] = requestParameters['expectedContentDisposition'];
        }

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        if (requestParameters['gzipped'] != null) {
            queryParameters['gzipped'] = requestParameters['gzipped'];
        }

        if (requestParameters['holderIdentifier'] != null) {
            queryParameters['holderIdentifier'] = requestParameters['holderIdentifier'];
        }

        if (requestParameters['holderType'] != null) {
            queryParameters['holderType'] = requestParameters['holderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/floatSeries/csv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get values of a float series
     */
    async getFloatSeriesValuesCSV(requestParameters: GetFloatSeriesValuesCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getFloatSeriesValuesCSVRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get float series values
     */
    async getFloatSeriesValuesProtoRaw(requestParameters: GetFloatSeriesValuesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['attribute'] == null) {
            throw new runtime.RequiredError(
                'attribute',
                'Required parameter "attribute" was null or undefined when calling getFloatSeriesValuesProto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attribute'] != null) {
            queryParameters['attribute'] = requestParameters['attribute'];
        }

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        if (requestParameters['includePreview'] != null) {
            queryParameters['includePreview'] = requestParameters['includePreview'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['lineage'] != null) {
            queryParameters['lineage'] = requestParameters['lineage'];
        }

        if (requestParameters['lineageEntityType'] != null) {
            queryParameters['lineageEntityType'] = requestParameters['lineageEntityType'];
        }

        if (requestParameters['skipToStep'] != null) {
            queryParameters['skipToStep'] = requestParameters['skipToStep'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/attributes/series/float`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get float series values
     */
    async getFloatSeriesValuesProto(requestParameters: GetFloatSeriesValuesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getFloatSeriesValuesProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get histogram series view
     */
    async getHistogramTimeSeriesViewRaw(requestParameters: GetHistogramTimeSeriesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistogramSeriesViewResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getHistogramTimeSeriesView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/timeseries/histogram/view`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HistogramSeriesViewRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistogramSeriesViewResponseFromJSON(jsonValue));
    }

    /**
     * Get histogram series view
     */
    async getHistogramTimeSeriesView(requestParameters: GetHistogramTimeSeriesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistogramSeriesViewResponse> {
        const response = await this.getHistogramTimeSeriesViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a latest report version
     */
    async getLatestPublishedReportVersionRaw(requestParameters: GetLatestPublishedReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling getLatestPublishedReportVersion().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling getLatestPublishedReportVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/{reportId}/latestVersion`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionDTOFromJSON(jsonValue));
    }

    /**
     * Retrieve a latest report version
     */
    async getLatestPublishedReportVersion(requestParameters: GetLatestPublishedReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionDTO> {
        const response = await this.getLatestPublishedReportVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get view
     */
    async getLeaderboardViewRaw(requestParameters: GetLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardViewDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling getLeaderboardView().'
            );
        }

        if (requestParameters['viewId'] == null) {
            throw new runtime.RequiredError(
                'viewId',
                'Required parameter "viewId" was null or undefined when calling getLeaderboardView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/views/{viewId}`.replace(`{${"viewId"}}`, encodeURIComponent(String(requestParameters['viewId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardViewDTOFromJSON(jsonValue));
    }

    /**
     * Get view
     */
    async getLeaderboardView(requestParameters: GetLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardViewDTO> {
        const response = await this.getLeaderboardViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get multiple float series values
     */
    async getMultipleFloatSeriesValuesProtoRaw(requestParameters: GetMultipleFloatSeriesValuesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getMultipleFloatSeriesValuesProto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/attributes/series/float`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FloatTimeSeriesValuesRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get multiple float series values
     */
    async getMultipleFloatSeriesValuesProto(requestParameters: GetMultipleFloatSeriesValuesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getMultipleFloatSeriesValuesProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a report version
     */
    async getReportVersionRaw(requestParameters: GetReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling getReportVersion().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling getReportVersion().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling getReportVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/{reportId}/versions/{versionId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionDTOFromJSON(jsonValue));
    }

    /**
     * Retrieve a report version
     */
    async getReportVersion(requestParameters: GetReportVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionDTO> {
        const response = await this.getReportVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get source runs of series data point
     */
    async getSeriesPointSourceRaw(requestParameters: GetSeriesPointSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesPointSourceResponseDTO>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getSeriesPointSource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/timeseries/points/source`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SeriesPointSourceRequestDTOToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeriesPointSourceResponseDTOFromJSON(jsonValue));
    }

    /**
     * Get source runs of series data point
     */
    async getSeriesPointSource(requestParameters: GetSeriesPointSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesPointSourceResponseDTO> {
        const response = await this.getSeriesPointSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get series values
     */
    async getSeriesValuesRaw(requestParameters: GetSeriesValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesValuesResponseDTO>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getSeriesValues().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['useDeprecatedStringFields'] != null) {
            queryParameters['useDeprecatedStringFields'] = requestParameters['useDeprecatedStringFields'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/series`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SeriesValuesRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeriesValuesResponseDTOFromJSON(jsonValue));
    }

    /**
     * Get series values
     */
    async getSeriesValues(requestParameters: GetSeriesValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesValuesResponseDTO> {
        const response = await this.getSeriesValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get series values
     */
    async getSeriesValuesProtoRaw(requestParameters: GetSeriesValuesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getSeriesValuesProto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['useDeprecatedStringFields'] != null) {
            queryParameters['useDeprecatedStringFields'] = requestParameters['useDeprecatedStringFields'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/attributes/series`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SeriesValuesRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get series values
     */
    async getSeriesValuesProto(requestParameters: GetSeriesValuesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getSeriesValuesProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get string series values
     * @deprecated
     */
    async getStringSeriesValuesRaw(requestParameters: GetStringSeriesValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringSeriesValuesDTO>> {
        if (requestParameters['attribute'] == null) {
            throw new runtime.RequiredError(
                'attribute',
                'Required parameter "attribute" was null or undefined when calling getStringSeriesValues().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attribute'] != null) {
            queryParameters['attribute'] = requestParameters['attribute'];
        }

        if (requestParameters['experimentId'] != null) {
            queryParameters['experimentId'] = requestParameters['experimentId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxSingleValueLength'] != null) {
            queryParameters['maxSingleValueLength'] = requestParameters['maxSingleValueLength'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/series/string`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringSeriesValuesDTOFromJSON(jsonValue));
    }

    /**
     * Get string series values
     * @deprecated
     */
    async getStringSeriesValues(requestParameters: GetStringSeriesValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringSeriesValuesDTO> {
        const response = await this.getStringSeriesValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get series view
     */
    async getTimeSeriesViewRaw(requestParameters: GetTimeSeriesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeSeriesViewResponse>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getTimeSeriesView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/timeseries/view`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TimeSeriesViewRequestToJSON(requestParameters['request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimeSeriesViewResponseFromJSON(jsonValue));
    }

    /**
     * Get series view
     */
    async getTimeSeriesView(requestParameters: GetTimeSeriesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeSeriesViewResponse> {
        const response = await this.getTimeSeriesViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get bucketed timeseries data
     */
    async getTimeseriesBucketsProtoRaw(requestParameters: GetTimeseriesBucketsProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling getTimeseriesBucketsProto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/attributes/timeseries/buckets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['request'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get bucketed timeseries data
     */
    async getTimeseriesBucketsProto(requestParameters: GetTimeseriesBucketsProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getTimeseriesBucketsProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List dashboard versions of a branch
     */
    async listDashboardBranchVersionsRaw(requestParameters: ListDashboardBranchVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageDTODashboardVersionDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listDashboardBranchVersions().'
            );
        }

        if (requestParameters['versionBranch'] == null) {
            throw new runtime.RequiredError(
                'versionBranch',
                'Required parameter "versionBranch" was null or undefined when calling listDashboardBranchVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['drafts'] != null) {
            queryParameters['drafts'] = requestParameters['drafts'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['substringQuery'] != null) {
            queryParameters['substringQuery'] = requestParameters['substringQuery'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/list/versions/{versionBranch}`.replace(`{${"versionBranch"}}`, encodeURIComponent(String(requestParameters['versionBranch']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageDTODashboardVersionDTOFromJSON(jsonValue));
    }

    /**
     * List dashboard versions of a branch
     */
    async listDashboardBranchVersions(requestParameters: ListDashboardBranchVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageDTODashboardVersionDTO> {
        const response = await this.listDashboardBranchVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List latest versions of dashboard
     */
    async listDashboardsRaw(requestParameters: ListDashboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardListDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listDashboards().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['branchIds'] != null) {
            queryParameters['branchIds'] = requestParameters['branchIds'];
        }

        if (requestParameters['dashboardType'] != null) {
            queryParameters['dashboardType'] = requestParameters['dashboardType'];
        }

        if (requestParameters['drafts'] != null) {
            queryParameters['drafts'] = requestParameters['drafts'];
        }

        if (requestParameters['owners'] != null) {
            queryParameters['owners'] = requestParameters['owners'];
        }

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardListDTOFromJSON(jsonValue));
    }

    /**
     * List latest versions of dashboard
     */
    async listDashboards(requestParameters: ListDashboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardListDTO> {
        const response = await this.listDashboardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List views in project
     */
    async listLeaderboardViewsRaw(requestParameters: ListLeaderboardViewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardViewListDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listLeaderboardViews().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/views`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardViewListDTOFromJSON(jsonValue));
    }

    /**
     * List views in project
     */
    async listLeaderboardViews(requestParameters: ListLeaderboardViewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardViewListDTO> {
        const response = await this.listLeaderboardViewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List drafts of reports belonging to the authenticated user
     */
    async listReportDraftsMetadataRaw(requestParameters: ListReportDraftsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionListDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listReportDraftsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['reportIds'] != null) {
            queryParameters['reportIds'] = requestParameters['reportIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/versions/drafts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionListDTOFromJSON(jsonValue));
    }

    /**
     * List drafts of reports belonging to the authenticated user
     */
    async listReportDraftsMetadata(requestParameters: ListReportDraftsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionListDTO> {
        const response = await this.listReportDraftsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List report versions\' metadata
     */
    async listReportVersionsMetadataRaw(requestParameters: ListReportVersionsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionListDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listReportVersionsMetadata().'
            );
        }

        if (requestParameters['reportIds'] == null) {
            throw new runtime.RequiredError(
                'reportIds',
                'Required parameter "reportIds" was null or undefined when calling listReportVersionsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['reportIds'] != null) {
            queryParameters['reportIds'] = requestParameters['reportIds'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/versions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionListDTOFromJSON(jsonValue));
    }

    /**
     * List report versions\' metadata
     */
    async listReportVersionsMetadata(requestParameters: ListReportVersionsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionListDTO> {
        const response = await this.listReportVersionsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List reports\' metadata
     */
    async listReportsMetadataRaw(requestParameters: ListReportsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportMetadataListDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listReportsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['reportIds'] != null) {
            queryParameters['reportIds'] = requestParameters['reportIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportMetadataListDTOFromJSON(jsonValue));
    }

    /**
     * List reports\' metadata
     */
    async listReportsMetadata(requestParameters: ListReportsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportMetadataListDTO> {
        const response = await this.listReportsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List run color lists in project
     */
    async listRunColorListsRaw(requestParameters: ListRunColorListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunColorListsDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling listRunColorLists().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runColorLists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RunColorListsDTOFromJSON(jsonValue));
    }

    /**
     * List run color lists in project
     */
    async listRunColorLists(requestParameters: ListRunColorListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RunColorListsDTO> {
        const response = await this.listRunColorListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tracking data
     */
    async listTrackingDataRaw(requestParameters: ListTrackingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrackingDataDTO>>> {
        if (requestParameters['projectIdentifiers'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifiers',
                'Required parameter "projectIdentifiers" was null or undefined when calling listTrackingData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/tracking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['projectIdentifiers'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackingDataDTOFromJSON));
    }

    /**
     * List tracking data
     */
    async listTrackingData(requestParameters: ListTrackingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrackingDataDTO>> {
        const response = await this.listTrackingDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Multi search leaderboard entries
     */
    async multiSearchLeaderboardEntriesRaw(requestParameters: MultiSearchLeaderboardEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LeaderboardEntriesSearchResultDTO>>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling multiSearchLeaderboardEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/entries/msearch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['params']!.map(MultiSearchLeaderboardEntriesParamsDTOToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LeaderboardEntriesSearchResultDTOFromJSON));
    }

    /**
     * Multi search leaderboard entries
     */
    async multiSearchLeaderboardEntries(requestParameters: MultiSearchLeaderboardEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LeaderboardEntriesSearchResultDTO>> {
        const response = await this.multiSearchLeaderboardEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates attribute style settings
     */
    async putAttributeStyleSettingsRaw(requestParameters: PutAttributeStyleSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling putAttributeStyleSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/style/putAttributeStyleSettings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AttributeStyleSettingsParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates or updates attribute style settings
     */
    async putAttributeStyleSettings(requestParameters: PutAttributeStyleSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putAttributeStyleSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates or overwrites colors in a run color list
     */
    async putRunColorsRaw(requestParameters: PutRunColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunColorListDTO>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling putRunColors().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runColorLists/putColors`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutRunColorsParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RunColorListDTOFromJSON(jsonValue));
    }

    /**
     * Creates or overwrites colors in a run color list
     */
    async putRunColors(requestParameters: PutRunColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RunColorListDTO> {
        const response = await this.putRunColorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attribute definitions of an experiment
     */
    async queryAttributeDefinitionsRaw(requestParameters: QueryAttributeDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttributesTreeSearchResultDTO>> {
        if (requestParameters['experimentIdentifier'] == null) {
            throw new runtime.RequiredError(
                'experimentIdentifier',
                'Required parameter "experimentIdentifier" was null or undefined when calling queryAttributeDefinitions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attributeType'] != null) {
            queryParameters['attributeType'] = requestParameters['attributeType'];
        }

        if (requestParameters['experimentIdentifier'] != null) {
            queryParameters['experimentIdentifier'] = requestParameters['experimentIdentifier'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['prefix'] != null) {
            queryParameters['prefix'] = requestParameters['prefix'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/queryAttributeDefinitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttributesTreeSearchResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries attribute definitions of an experiment
     */
    async queryAttributeDefinitions(requestParameters: QueryAttributeDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttributesTreeSearchResultDTO> {
        const response = await this.queryAttributeDefinitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attribute definitions with different values
     */
    async queryAttributeDefinitionsOnlyWithDiffsRaw(requestParameters: QueryAttributeDefinitionsOnlyWithDiffsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueryAttributeDefinitionsResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling queryAttributeDefinitionsOnlyWithDiffs().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling queryAttributeDefinitionsOnlyWithDiffs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/attributes/definitions/query-diffs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributeDefinitionsBodyDTOToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryAttributeDefinitionsResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries attribute definitions with different values
     */
    async queryAttributeDefinitionsOnlyWithDiffs(requestParameters: QueryAttributeDefinitionsOnlyWithDiffsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueryAttributeDefinitionsResultDTO> {
        const response = await this.queryAttributeDefinitionsOnlyWithDiffsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries prioritized attribute definitions, definitions that fulfill the priority queryare returned as first.
     */
    async queryAttributeDefinitionsPrioritizedRaw(requestParameters: QueryAttributeDefinitionsPrioritizedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueryAttributeDefinitionsPrioritizedResultDTO>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling queryAttributeDefinitionsPrioritized().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/attributes/definitions/prioritized`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributeDefinitionsPrioritizedBodyDTOToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryAttributeDefinitionsPrioritizedResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries prioritized attribute definitions, definitions that fulfill the priority queryare returned as first.
     */
    async queryAttributeDefinitionsPrioritized(requestParameters: QueryAttributeDefinitionsPrioritizedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueryAttributeDefinitionsPrioritizedResultDTO> {
        const response = await this.queryAttributeDefinitionsPrioritizedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attribute definitions of an experiment
     */
    async queryAttributeDefinitionsProtoRaw(requestParameters: QueryAttributeDefinitionsProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['experimentIdentifier'] == null) {
            throw new runtime.RequiredError(
                'experimentIdentifier',
                'Required parameter "experimentIdentifier" was null or undefined when calling queryAttributeDefinitionsProto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attributeType'] != null) {
            queryParameters['attributeType'] = requestParameters['attributeType'];
        }

        if (requestParameters['experimentIdentifier'] != null) {
            queryParameters['experimentIdentifier'] = requestParameters['experimentIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/attributes/queryAttributeDefinitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Queries attribute definitions of an experiment
     */
    async queryAttributeDefinitionsProto(requestParameters: QueryAttributeDefinitionsProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.queryAttributeDefinitionsProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attribute definitions
     */
    async queryAttributeDefinitionsWithinProjectRaw(requestParameters: QueryAttributeDefinitionsWithinProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueryAttributeDefinitionsResultDTO>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling queryAttributeDefinitionsWithinProject().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/attributes/definitions/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributeDefinitionsBodyDTOToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryAttributeDefinitionsResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries attribute definitions
     */
    async queryAttributeDefinitionsWithinProject(requestParameters: QueryAttributeDefinitionsWithinProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueryAttributeDefinitionsResultDTO> {
        const response = await this.queryAttributeDefinitionsWithinProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attributes style settings
     */
    async queryAttributeStyleSettingsRaw(requestParameters: QueryAttributeStyleSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttributesStyleSettingsResultDTO>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling queryAttributeStyleSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/style/queryAttributeStyleSettings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchAttributesStyleSettingsParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttributesStyleSettingsResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries attributes style settings
     */
    async queryAttributeStyleSettings(requestParameters: QueryAttributeStyleSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttributesStyleSettingsResultDTO> {
        const response = await this.queryAttributeStyleSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attributes
     */
    async queryAttributesWithinProjectRaw(requestParameters: QueryAttributesWithinProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueryAttributesResultDTO>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling queryAttributesWithinProject().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/attributes/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributesBodyDTOToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryAttributesResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries attributes
     */
    async queryAttributesWithinProject(requestParameters: QueryAttributesWithinProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueryAttributesResultDTO> {
        const response = await this.queryAttributesWithinProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attributes
     */
    async queryAttributesWithinProjectProtoRaw(requestParameters: QueryAttributesWithinProjectProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling queryAttributesWithinProjectProto().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling queryAttributesWithinProjectProto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/leaderboard/attributes/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributesBodyDTOToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Queries attributes
     */
    async queryAttributesWithinProjectProto(requestParameters: QueryAttributesWithinProjectProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.queryAttributesWithinProjectProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries attribute definitions of an experiment
     */
    async queryFilteredAttributeDefinitionsRaw(requestParameters: QueryFilteredAttributeDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttributesSearchResultDTO>> {
        if (requestParameters['experimentIdentifier'] == null) {
            throw new runtime.RequiredError(
                'experimentIdentifier',
                'Required parameter "experimentIdentifier" was null or undefined when calling queryFilteredAttributeDefinitions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attributeType'] != null) {
            queryParameters['attributeType'] = requestParameters['attributeType'];
        }

        if (requestParameters['experimentIdentifier'] != null) {
            queryParameters['experimentIdentifier'] = requestParameters['experimentIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/attributes/queryAttributeDefinitions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributeDefinitionsDTOToJSON(requestParameters['queryAttributeDefinitionsDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttributesSearchResultDTOFromJSON(jsonValue));
    }

    /**
     * Queries attribute definitions of an experiment
     */
    async queryFilteredAttributeDefinitions(requestParameters: QueryFilteredAttributeDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttributesSearchResultDTO> {
        const response = await this.queryFilteredAttributeDefinitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries colors of entities in a run color list
     */
    async queryRunColorsRaw(requestParameters: QueryRunColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunColorsDTO>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling queryRunColors().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runColorLists/queryColors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryRunColorsParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RunColorsDTOFromJSON(jsonValue));
    }

    /**
     * Queries colors of entities in a run color list
     */
    async queryRunColors(requestParameters: QueryRunColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RunColorsDTO> {
        const response = await this.queryRunColorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Currently only String attribute type is supported
     * Queries unique attribute values within a project
     */
    async queryUniqueAttributeValuesRaw(requestParameters: QueryUniqueAttributeValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueryAttributeValuesResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling queryUniqueAttributeValues().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling queryUniqueAttributeValues().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/attributes/values/unique`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryAttributeValuesBodyDTOToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryAttributeValuesResultDTOFromJSON(jsonValue));
    }

    /**
     * Currently only String attribute type is supported
     * Queries unique attribute values within a project
     */
    async queryUniqueAttributeValues(requestParameters: QueryUniqueAttributeValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueryAttributeValuesResultDTO> {
        const response = await this.queryUniqueAttributeValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove status endpoint override
     */
    async resumeStatusUsingPOSTRaw(requestParameters: ResumeStatusUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/status/resume`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove status endpoint override
     */
    async resumeStatusUsingPOST(requestParameters: ResumeStatusUsingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resumeStatusUsingPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve events
     */
    async retrieveAuditSessionRaw(requestParameters: RetrieveAuditSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSessionDTO>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling retrieveAuditSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/audited-sessions/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSessionDTOFromJSON(jsonValue));
    }

    /**
     * Retrieve events
     */
    async retrieveAuditSession(requestParameters: RetrieveAuditSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSessionDTO> {
        const response = await this.retrieveAuditSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search leaderboard entries across all accessible projects and workspaces
     */
    async searchGlobalLeaderboardEntriesProtoRaw(requestParameters: SearchGlobalLeaderboardEntriesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling searchGlobalLeaderboardEntriesProto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/leaderboard/entries/global/search/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalSearchParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search leaderboard entries across all accessible projects and workspaces
     */
    async searchGlobalLeaderboardEntriesProto(requestParameters: SearchGlobalLeaderboardEntriesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.searchGlobalLeaderboardEntriesProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List definitions of all attributes in project
     */
    async searchLeaderboardAttributesRaw(requestParameters: SearchLeaderboardAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttributesSearchResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling searchLeaderboardAttributes().'
            );
        }

        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling searchLeaderboardAttributes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attributeType'] != null) {
            queryParameters['attributeType'] = requestParameters['attributeType'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/attributes/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchLeaderboardParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttributesSearchResultDTOFromJSON(jsonValue));
    }

    /**
     * List definitions of all attributes in project
     */
    async searchLeaderboardAttributes(requestParameters: SearchLeaderboardAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttributesSearchResultDTO> {
        const response = await this.searchLeaderboardAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get leaderboard
     */
    async searchLeaderboardEntriesRaw(requestParameters: SearchLeaderboardEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardEntriesSearchResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling searchLeaderboardEntries().'
            );
        }

        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling searchLeaderboardEntries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/entries/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchLeaderboardEntriesParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardEntriesSearchResultDTOFromJSON(jsonValue));
    }

    /**
     * Get leaderboard
     */
    async searchLeaderboardEntries(requestParameters: SearchLeaderboardEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardEntriesSearchResultDTO> {
        const response = await this.searchLeaderboardEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get leaderboard
     */
    async searchLeaderboardEntriesProtoRaw(requestParameters: SearchLeaderboardEntriesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling searchLeaderboardEntriesProto().'
            );
        }

        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling searchLeaderboardEntriesProto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/proto/leaderboard/entries/search/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchLeaderboardEntriesParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get leaderboard
     */
    async searchLeaderboardEntriesProto(requestParameters: SearchLeaderboardEntriesProtoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.searchLeaderboardEntriesProtoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tags defined in experiments within project
     */
    async searchLeaderboardTagsRaw(requestParameters: SearchLeaderboardTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TagsSearchResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling searchLeaderboardTags().'
            );
        }

        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling searchLeaderboardTags().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['attributePath'] != null) {
            queryParameters['attributePath'] = requestParameters['attributePath'];
        }

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/tags/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchLeaderboardParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TagsSearchResultDTOFromJSON(jsonValue));
    }

    /**
     * Get tags defined in experiments within project
     */
    async searchLeaderboardTags(requestParameters: SearchLeaderboardTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TagsSearchResultDTO> {
        const response = await this.searchLeaderboardTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get leaderboard
     */
    async searchUserRunsRaw(requestParameters: SearchUserRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardEntriesSearchResultDTO>> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling searchUserRuns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/leaderboard/entries/searchUserRuns`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchUserRunsParamsDTOToJSON(requestParameters['params']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardEntriesSearchResultDTOFromJSON(jsonValue));
    }

    /**
     * Get leaderboard
     */
    async searchUserRuns(requestParameters: SearchUserRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardEntriesSearchResultDTO> {
        const response = await this.searchUserRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set default
     */
    async setDefaultViewRaw(requestParameters: SetDefaultViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['setDefaultOperation'] == null) {
            throw new runtime.RequiredError(
                'setDefaultOperation',
                'Required parameter "setDefaultOperation" was null or undefined when calling setDefaultView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/views/setDefault`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeaderboardViewSetDefaultDTOToJSON(requestParameters['setDefaultOperation']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set default
     */
    async setDefaultView(requestParameters: SetDefaultViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultViewRaw(requestParameters, initOverrides);
    }

    /**
     * Start or continue session
     */
    async startOrContinueAuditSessionRaw(requestParameters: StartOrContinueAuditSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSessionInfoDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/audited-sessions/get`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSessionInfoDTOFromJSON(jsonValue));
    }

    /**
     * Start or continue session
     */
    async startOrContinueAuditSession(requestParameters: StartOrContinueAuditSessionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSessionInfoDTO> {
        const response = await this.startOrContinueAuditSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Store event
     */
    async storeAuditEventRaw(requestParameters: StoreAuditEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['event'] == null) {
            throw new runtime.RequiredError(
                'event',
                'Required parameter "event" was null or undefined when calling storeAuditEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/audited-sessions/storeEvent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionEventDTOToJSON(requestParameters['event']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Store event
     */
    async storeAuditEvent(requestParameters: StoreAuditEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeAuditEventRaw(requestParameters, initOverrides);
    }

    /**
     * Store event
     */
    async storeEventRaw(requestParameters: StoreEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['event'] == null) {
            throw new runtime.RequiredError(
                'event',
                'Required parameter "event" was null or undefined when calling storeEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/userAnalytics/storeEvent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserEventDTOToJSON(requestParameters['event']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Store event
     */
    async storeEvent(requestParameters: StoreEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeEventRaw(requestParameters, initOverrides);
    }

    /**
     * Override status endpoint to always return unhealthy
     */
    async suspendStatusUsingPOSTRaw(requestParameters: SuspendStatusUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/status/suspend`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Override status endpoint to always return unhealthy
     */
    async suspendStatusUsingPOST(requestParameters: SuspendStatusUsingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.suspendStatusUsingPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * get health status of Neptune
     */
    async systemStatusRaw(requestParameters: SystemStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthCheckStatusDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/status/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthCheckStatusDTOFromJSON(jsonValue));
    }

    /**
     * get health status of Neptune
     */
    async systemStatus(requestParameters: SystemStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthCheckStatusDTO> {
        const response = await this.systemStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unarchive Runs
     */
    async unarchiveRunsRaw(requestParameters: UnarchiveRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkOpResultDTO>> {
        if (requestParameters['runList'] == null) {
            throw new runtime.RequiredError(
                'runList',
                'Required parameter "runList" was null or undefined when calling unarchiveRuns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runs:unarchive`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunListDTOToJSON(requestParameters['runList']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkOpResultDTOFromJSON(jsonValue));
    }

    /**
     * Unarchive Runs
     */
    async unarchiveRuns(requestParameters: UnarchiveRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkOpResultDTO> {
        const response = await this.unarchiveRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update dashboard
     */
    async updateDashboardRaw(requestParameters: UpdateDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardDTO>> {
        if (requestParameters['dashboardId'] == null) {
            throw new runtime.RequiredError(
                'dashboardId',
                'Required parameter "dashboardId" was null or undefined when calling updateDashboard().'
            );
        }

        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling updateDashboard().'
            );
        }

        if (requestParameters['updateDashboard'] == null) {
            throw new runtime.RequiredError(
                'updateDashboard',
                'Required parameter "updateDashboard" was null or undefined when calling updateDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/{dashboardId}`.replace(`{${"dashboardId"}}`, encodeURIComponent(String(requestParameters['dashboardId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDashboardDTOToJSON(requestParameters['updateDashboard']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardDTOFromJSON(jsonValue));
    }

    /**
     * Update dashboard
     */
    async updateDashboard(requestParameters: UpdateDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardDTO> {
        const response = await this.updateDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update dashboard version
     */
    async updateDashboardVersionRaw(requestParameters: UpdateDashboardVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardVersionDTO>> {
        if (requestParameters['dashboardId'] == null) {
            throw new runtime.RequiredError(
                'dashboardId',
                'Required parameter "dashboardId" was null or undefined when calling updateDashboardVersion().'
            );
        }

        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling updateDashboardVersion().'
            );
        }

        if (requestParameters['updateDashboardVersionDTO'] == null) {
            throw new runtime.RequiredError(
                'updateDashboardVersionDTO',
                'Required parameter "updateDashboardVersionDTO" was null or undefined when calling updateDashboardVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['updateTimestamp'] != null) {
            queryParameters['updateTimestamp'] = requestParameters['updateTimestamp'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/dashboards/{dashboardId}/version`.replace(`{${"dashboardId"}}`, encodeURIComponent(String(requestParameters['dashboardId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDashboardVersionDTOToJSON(requestParameters['updateDashboardVersionDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardVersionDTOFromJSON(jsonValue));
    }

    /**
     * Update dashboard version
     */
    async updateDashboardVersion(requestParameters: UpdateDashboardVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardVersionDTO> {
        const response = await this.updateDashboardVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update view
     */
    async updateLeaderboardViewRaw(requestParameters: UpdateLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardViewDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling updateLeaderboardView().'
            );
        }

        if (requestParameters['viewId'] == null) {
            throw new runtime.RequiredError(
                'viewId',
                'Required parameter "viewId" was null or undefined when calling updateLeaderboardView().'
            );
        }

        if (requestParameters['updateView'] == null) {
            throw new runtime.RequiredError(
                'updateView',
                'Required parameter "updateView" was null or undefined when calling updateLeaderboardView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/views/{viewId}`.replace(`{${"viewId"}}`, encodeURIComponent(String(requestParameters['viewId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LeaderboardViewUpdateDTOToJSON(requestParameters['updateView']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LeaderboardViewDTOFromJSON(jsonValue));
    }

    /**
     * Update view
     */
    async updateLeaderboardView(requestParameters: UpdateLeaderboardViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardViewDTO> {
        const response = await this.updateLeaderboardViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a draft of a report
     */
    async updateReportDraftRaw(requestParameters: UpdateReportDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling updateReportDraft().'
            );
        }

        if (requestParameters['publishIfUnmodifiedSince'] == null) {
            throw new runtime.RequiredError(
                'publishIfUnmodifiedSince',
                'Required parameter "publishIfUnmodifiedSince" was null or undefined when calling updateReportDraft().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling updateReportDraft().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling updateReportDraft().'
            );
        }

        if (requestParameters['reportDraft'] == null) {
            throw new runtime.RequiredError(
                'reportDraft',
                'Required parameter "reportDraft" was null or undefined when calling updateReportDraft().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['publishIfUnmodifiedSince'] != null) {
            queryParameters['publishIfUnmodifiedSince'] = (requestParameters['publishIfUnmodifiedSince'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/{reportId}/versions/{versionId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReportVersionDTOToJSON(requestParameters['reportDraft']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionDTOFromJSON(jsonValue));
    }

    /**
     * Update a draft of a report
     */
    async updateReportDraft(requestParameters: UpdateReportDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionDTO> {
        const response = await this.updateReportDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update metadata of a report version
     */
    async updateReportVersionMetadataRaw(requestParameters: UpdateReportVersionMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportVersionMetadataDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling updateReportVersionMetadata().'
            );
        }

        if (requestParameters['publishIfUnmodifiedSince'] == null) {
            throw new runtime.RequiredError(
                'publishIfUnmodifiedSince',
                'Required parameter "publishIfUnmodifiedSince" was null or undefined when calling updateReportVersionMetadata().'
            );
        }

        if (requestParameters['reportId'] == null) {
            throw new runtime.RequiredError(
                'reportId',
                'Required parameter "reportId" was null or undefined when calling updateReportVersionMetadata().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling updateReportVersionMetadata().'
            );
        }

        if (requestParameters['metadata'] == null) {
            throw new runtime.RequiredError(
                'metadata',
                'Required parameter "metadata" was null or undefined when calling updateReportVersionMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['publishIfUnmodifiedSince'] != null) {
            queryParameters['publishIfUnmodifiedSince'] = (requestParameters['publishIfUnmodifiedSince'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/reports/{reportId}/versions/{versionId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters['reportId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReportVersionMetadataDTOToJSON(requestParameters['metadata']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportVersionMetadataDTOFromJSON(jsonValue));
    }

    /**
     * Update metadata of a report version
     */
    async updateReportVersionMetadata(requestParameters: UpdateReportVersionMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportVersionMetadataDTO> {
        const response = await this.updateReportVersionMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tags in experiments
     */
    async updateTags2Raw(requestParameters: UpdateTags2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkOpResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling updateTags2().'
            );
        }

        if (requestParameters['updateTagsParams'] == null) {
            throw new runtime.RequiredError(
                'updateTagsParams',
                'Required parameter "updateTagsParams" was null or undefined when calling updateTags2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/experiments/tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTagsParamsToJSON(requestParameters['updateTagsParams']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkOpResultDTOFromJSON(jsonValue));
    }

    /**
     * Update tags in experiments
     */
    async updateTags2(requestParameters: UpdateTags2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkOpResultDTO> {
        const response = await this.updateTags2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tags in multiple projects
     */
    async updateTagsBulkRaw(requestParameters: UpdateTagsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectBulkOpResultDTO>> {
        if (requestParameters['updateTagsBulkParams'] == null) {
            throw new runtime.RequiredError(
                'updateTagsBulkParams',
                'Required parameter "updateTagsBulkParams" was null or undefined when calling updateTagsBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/runs:modifyTags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTagsBulkParamsToJSON(requestParameters['updateTagsBulkParams']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectBulkOpResultDTOFromJSON(jsonValue));
    }

    /**
     * Update tags in multiple projects
     */
    async updateTagsBulk(requestParameters: UpdateTagsBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectBulkOpResultDTO> {
        const response = await this.updateTagsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate experiments clipboard
     */
    async validateExperimentsClipboardRaw(requestParameters: ValidateExperimentsClipboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkOpResultDTO>> {
        if (requestParameters['projectIdentifier'] == null) {
            throw new runtime.RequiredError(
                'projectIdentifier',
                'Required parameter "projectIdentifier" was null or undefined when calling validateExperimentsClipboard().'
            );
        }

        if (requestParameters['trashed'] == null) {
            throw new runtime.RequiredError(
                'trashed',
                'Required parameter "trashed" was null or undefined when calling validateExperimentsClipboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectIdentifier'] != null) {
            queryParameters['projectIdentifier'] = requestParameters['projectIdentifier'];
        }

        if (requestParameters['trashed'] != null) {
            queryParameters['trashed'] = requestParameters['trashed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xNeptuneClientMetadata'] != null) {
            headerParameters['X-Neptune-Client-Metadata'] = String(requestParameters['xNeptuneClientMetadata']);
        }

        const response = await this.request({
            path: `/api/leaderboard/v1/experiments/select`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['experimentIdentifiers'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkOpResultDTOFromJSON(jsonValue));
    }

    /**
     * Validate experiments clipboard
     */
    async validateExperimentsClipboard(requestParameters: ValidateExperimentsClipboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkOpResultDTO> {
        const response = await this.validateExperimentsClipboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetFloatSeriesValuesLineageEnum = {
    Full: 'FULL',
    None: 'NONE'
} as const;
export type GetFloatSeriesValuesLineageEnum = typeof GetFloatSeriesValuesLineageEnum[keyof typeof GetFloatSeriesValuesLineageEnum];
/**
 * @export
 */
export const GetFloatSeriesValuesLineageEntityTypeEnum = {
    Run: 'RUN',
    Experiment: 'EXPERIMENT'
} as const;
export type GetFloatSeriesValuesLineageEntityTypeEnum = typeof GetFloatSeriesValuesLineageEntityTypeEnum[keyof typeof GetFloatSeriesValuesLineageEntityTypeEnum];
/**
 * @export
 */
export const GetFloatSeriesValuesCSVExpectedContentDispositionEnum = {
    Inline: 'inline',
    Attachment: 'attachment'
} as const;
export type GetFloatSeriesValuesCSVExpectedContentDispositionEnum = typeof GetFloatSeriesValuesCSVExpectedContentDispositionEnum[keyof typeof GetFloatSeriesValuesCSVExpectedContentDispositionEnum];
/**
 * @export
 */
export const GetFloatSeriesValuesProtoLineageEnum = {
    Full: 'FULL',
    None: 'NONE'
} as const;
export type GetFloatSeriesValuesProtoLineageEnum = typeof GetFloatSeriesValuesProtoLineageEnum[keyof typeof GetFloatSeriesValuesProtoLineageEnum];
/**
 * @export
 */
export const GetFloatSeriesValuesProtoLineageEntityTypeEnum = {
    Run: 'RUN',
    Experiment: 'EXPERIMENT'
} as const;
export type GetFloatSeriesValuesProtoLineageEntityTypeEnum = typeof GetFloatSeriesValuesProtoLineageEntityTypeEnum[keyof typeof GetFloatSeriesValuesProtoLineageEntityTypeEnum];
/**
 * @export
 */
export const ListDashboardBranchVersionsDraftsEnum = {
    False: 'false',
    True: 'true',
    All: 'all'
} as const;
export type ListDashboardBranchVersionsDraftsEnum = typeof ListDashboardBranchVersionsDraftsEnum[keyof typeof ListDashboardBranchVersionsDraftsEnum];
/**
 * @export
 */
export const ListDashboardsDashboardTypeEnum = {
    Compare: 'compare',
    Experiment: 'experiment',
    Report: 'report'
} as const;
export type ListDashboardsDashboardTypeEnum = typeof ListDashboardsDashboardTypeEnum[keyof typeof ListDashboardsDashboardTypeEnum];
/**
 * @export
 */
export const ListDashboardsDraftsEnum = {
    False: 'false',
    True: 'true',
    All: 'all'
} as const;
export type ListDashboardsDraftsEnum = typeof ListDashboardsDraftsEnum[keyof typeof ListDashboardsDraftsEnum];
/**
 * @export
 */
export const SearchLeaderboardTagsAttributePathEnum = {
    Tags: 'sys/tags',
    GroupTags: 'sys/group_tags'
} as const;
export type SearchLeaderboardTagsAttributePathEnum = typeof SearchLeaderboardTagsAttributePathEnum[keyof typeof SearchLeaderboardTagsAttributePathEnum];
